import { createContext, useContext } from 'react';

const InjectorLegacySingleton = { instance : null };

export const InjectorContext = createContext({ injector: null });

export const InjectorProvider = ({ children, injector }) => {
  InjectorLegacySingleton.instance = injector;
  
  return (
      <InjectorContext.Provider value= {{ injector: injector }} >
          {children}
      </InjectorContext.Provider>
  );
};

export function getInjectorLegacy() {
  return injectorOrFail(InjectorLegacySingleton.instance);
}

export function useInjector() {
  return injectorOrFail(useContext(InjectorContext));
}

function injectorOrFail(injector) {
  if (!injector) {
    console.error("Missing Injector");
    throw new Error('Missing angular injector for react');
  }

  return injector;
}